export const NETWORK_QUALITY_UPDATE = 'NETWORK_QUALITY_UPDATE';
export const NETWORK_QUALITY_TOAST_SHOW = 'NETWORK_QUALITY_TOAST_SHOW';
export const NETWORK_QUALITY_TOAST_CLEAR = 'NETWORK_QUALITY_TOAST_CLEAR';
